/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GetTagsAvailableForClientParams,
  ModelsTag,
  ModelsTagType,
  ResponseTag,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Tags<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Tags
   * @name GetAvailableLanguagesForSessions
   * @summary Endpoint to get for which there are active psychologists, sorted by a few priority languages and then alphabetically
   * @request GET:/api/v1/tags/available-languages/{sessionType}
   * @secure
   * @response `200` `(ResponseTag)[]` OK
   */
  getAvailableLanguagesForSessions = (
    sessionType: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseTag[], any>({
      path: `/api/v1/tags/available-languages/${sessionType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tags
   * @name GetSessionNoteTopicsByTheme
   * @summary  (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/tags/topics-by-theme/{themeKey}
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getSessionNoteTopicsByTheme = (
    themeKey: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], void>({
      path: `/api/v1/tags/topics-by-theme/${themeKey}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * @description This endpoint allows anonymous access.
 *
 * @tags Tags
 * @name GetSessionTypeTags
 * @summary Retrieves a list of types of sessions, filtered for active psychologists.
Explicitly excludes medical session type.
 * @request GET:/api/v1/tags/session-type
 * @secure
 * @response `200` `(ModelsTag)[]` OK
 */
  getSessionTypeTags = (params: RequestParams = {}) =>
    this.http.request<ModelsTag[], any>({
      path: `/api/v1/tags/session-type`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tags
   * @name GetTags
   * @summary  (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/tags/{tagType}
   * @secure
   * @response `200` `ModelsTagType` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getTags = (tagType: string, params: RequestParams = {}) =>
    this.http.request<ModelsTagType, void>({
      path: `/api/v1/tags/${tagType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tags
   * @name GetTagsAvailableForClient
   * @summary  (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/tags/{tagType}/available-for-client
   * @secure
   * @response `200` `ModelsTagType` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getTagsAvailableForClient = (
    { tagType, ...query }: GetTagsAvailableForClientParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsTagType, void>({
      path: `/api/v1/tags/${tagType}/available-for-client`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
